<script setup>
import { inject } from 'vue';
import InfiniteScroll from './InfiniteScroll.vue';
import Simple from './Simple.vue';

const dataView = inject('dataView');

const paginators = {
    infiniteScroll: InfiniteScroll,
    simple: Simple,
}
</script>

<template>
    <component :is="paginators[dataView.props.paginationType]" />
</template>
